import React, { useRef, useEffect } from "react";

import "./Article.less";

const calcAspectFit = ({ owidth, oheight, width, height }) => {
    const ratio = Math.min(width / owidth, height / oheight);
    return {
        width: owidth * ratio,
        height: oheight * ratio
    };
};

const Article = props => {
    const content = useRef(null);

    useEffect(() => {
        const wistiaVideos =
            content.current &&
            content.current.querySelectorAll("a[href*=wistia]");
        if (wistiaVideos) {
            wistiaVideos.forEach(video => {
                const container = video.parentElement.getClientRects()[0];
                const dimensions = {
                    owidth: 1280,
                    oheight: 720,
                    width: container.width / 2,
                    height: 720
                };
                const { width, height } = calcAspectFit(dimensions);
                const videoplayer = document.createElement("iframe");
                videoplayer.src = video.href;
                videoplayer.setAttribute("allowtransparency", true);
                videoplayer.setAttribute("allowfullscreen", true);
                videoplayer.setAttribute("mozallowfullscreen", true);
                videoplayer.setAttribute("webkitallowfullscreen", true);
                videoplayer.setAttribute("oallowfullscreen", true);
                videoplayer.setAttribute("msallowfullscreen", true);
                videoplayer.setAttribute("frameborder", 0);
                videoplayer.setAttribute("scrolling", "no");
                videoplayer.classList.add("wistia_embed");
                videoplayer.setAttribute("width", width);
                videoplayer.setAttribute("height", height);
                video.style.display = "none";
                video.parentElement.prepend(videoplayer);
            });
        }
    }, []);
    return (
        <article className="article__Item">
            <h2>{props.title}</h2>
            <div
                ref={content}
                className="article__Content"
                dangerouslySetInnerHTML={{ __html: props.content }}
            />
        </article>
    );
};

export default Article;
